import { Breadcrumb } from "antd";
import React from "react"
import { useState } from "react"
import { getCurrenciesDenominationsByCustomer } from "../../../networking/NetworkingCurrencies";
import useLookUpTables from "../../maintenance/complaints/useLookUpTables";
import { useEffect } from "react";
import AlertBox from "../../shared/AlertBox";
import CustomerSearch from "./CustomerSearch";
import ContactSearch from "./ContactSearch";
import IncomingInformationScreen  from "./incoming/IncomingInformationScreen";
import { getInstrumentsByCustomer } from "../../../networking/NetworkingInstruments";
import { getCustomerQPSBalances } from "../../../networking/NetworkingQPS";
import TicketSummary from "./TicketSummary";
import { getBeneficiariesByCustomerMin } from "../../../networking/NetworkingBeneficiaries";
import OutgoingInformationScreen from "./outgoing/OutgoingInformacionScreen";
import TicketSearchScreen from "./search/TicketSearchScreen";
import { newSearchCustomers } from "../../../networking/Networking";
import { formatToCurrencyWithScale } from "../../../helpers/FormatHelper";

const  TicketScreen = ({ticketType}) => {
    const [step, setStep] = useState(1);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [objCustomer, setObjCustomer] = useState({});
    const baseCCy= localStorage.getItem('BNBase Currency');
    const [instruments, setInstruments] = useState([]);
    const [deliveryMethods, setDeliveryMethods] = useState([]);
    const [defaultInstrument, setDefaultInstrument] = useState('');
    const [defaultSettlementMethod, setDefaultSettlementMethod] = useState('');   
    const [balances, setBalances] = useState([]);
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [customerList, setCustomerList] = useState([]);

    const [ticketScreenKey, setTicketScreenKey] = useState(0);

    const [objTicket, setObjTicket] = useState({
        TicketNo:0,
        CustomerID: -1,
        ContactID:-1,
        UserID: '',
        BeneficiaryId:-1,
        BeneficiaryName:'',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        TicketRows: [],
        UpdateToken:''
    });

    const [currencies, setCurrencies] = useState([]);
    const [settlementCurrenciesList, setSettlementCurrenciesList] = useState([]);
    const [customerID, setCustomerID] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [contactID, setContactID] = useState(0);
    const [contactName, setContactName] = useState(0);
    
    const blankTicket = {
        TicketNo:0,
        CustomerID: -1,
        ContactID:-1,
        UserID: '',
        BeneficiaryId:-1,
        BeneficiaryName:'',
        DeliveryDate: new Date().toLocaleDateString('en-US'), 
        TicketRows: [],
        UpdateToken:''
    }

    useEffect(() => {
        loadCustomers();
    }, []);

    useEffect(() => {
        if (ticketType !== undefined) {
            setObjTicket({...blankTicket});
            setStep(1);
        }
      }, [ticketType]);


    const loadCustomerInfo =async(customerID) =>{

        const balancesResponse = await getCustomerQPSBalances(customerID);
        if(balancesResponse && balancesResponse.balances)
        {
            balancesResponse.balances.forEach((row,index) =>{
                row['Balance'] = formatToCurrencyWithScale(row['Balance$'], row['Currency']);
            })
        }
        setBalances(balancesResponse.balances??[]);

        const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerID)
                
        if(currenciesResponse && currenciesResponse.currencies)
        {
            const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
            const finalCurrencies = [];
            const finalSettelementCurrencies = [];
            formattedCurrencies.forEach(element => {
            switch (element.Type) {
                case 'Payment':                    
                    if(balancesResponse.balances)
                    {
                        const balance = balancesResponse.balances.find(b => b.Currency === element.CurrencyID);
                        if(balance)
                        {
                            finalCurrencies.push(element);
                        }
                    }
                break;
                case 'Settlement':
                finalSettelementCurrencies.push(element);
                break;
                default:
                break;
            }
            });
            setCurrencies(finalCurrencies);
            setSettlementCurrenciesList(finalSettelementCurrencies);
        }
    }

    const loadInstruments = async(customerID) =>{
        const instrumentsResponse = await getInstrumentsByCustomer(customerID);
        if(instrumentsResponse){
            let jsonInstruments = instrumentsResponse.instruments;
            if (jsonInstruments !== undefined) {
                var incomingHelper = [];
                let deliveryMethods = {};
                for (var i = 0; i < jsonInstruments.length; i++) {
                    let instrumentElement = {
                        value: jsonInstruments[i].Instrument,
                        name: jsonInstruments[i].Instrument
                    };
                    
                    if (jsonInstruments[i].InstrumentType === ticketType) {
                        if(!jsonInstruments[i].Instrument.includes('Electronic') || ticketType === 'Incoming')
                        {
                            incomingHelper.push(instrumentElement);
                        }
                        let list = [];
                        if(jsonInstruments[i].DeliveryMethods && jsonInstruments[i].DeliveryMethods !== ''){
                            var methodsList = jsonInstruments[i].DeliveryMethods.split('§');
                            for(var j=0; j<methodsList.length; j++){
                                var item = {value:methodsList[j], name:methodsList[j]};
                                list.push(item);
                            }
                        }
                        deliveryMethods[jsonInstruments[i].Instrument] = list;
                    }
                }
                setInstruments(incomingHelper);
                setDeliveryMethods(deliveryMethods);
            }
        }
    }

    const loadBeneficiaries = async(customerID) =>{

        if(ticketType === 'Outgoing')
        {
            const resultBeneficiaries = await getBeneficiariesByCustomerMin(customerID, 'Authorized');

            if(resultBeneficiaries && resultBeneficiaries.beneficiaries) {
                    var benes = resultBeneficiaries.beneficiaries;
                    var helper = [];
                    for (var i = 0; i < benes.length; i++) {
                        benes[i].value = benes[i]["BeneficiaryID"];
                        benes[i].name = `${benes[i]["BeneficiaryName"]} - (B)`;
                        benes[i].RecipientType = "Beneficiary";

                        helper.push(benes[i]);
                    }
                    setBeneficiaries(helper);
                }
        }
        else{
            setBeneficiaries([]);
        }

    }

    const loadCustomers = async(customerID) =>{

        const response = await newSearchCustomers('', 0, 0);
        if(response && response.customers) {
                const filteredCustomers = response.customers.filter(c => c.Status === 'Authorized to deal');
                if(filteredCustomers)
                {
                    for (var i = 0; i < filteredCustomers.length; i++) {
                        filteredCustomers[i].value = filteredCustomers[i]["Customer ID"];
                        filteredCustomers[i].name =  `${filteredCustomers[i]["Customer Name"]} - (C)`;
                        filteredCustomers[i].Currencies = filteredCustomers[i]["Currencies$"];
                        filteredCustomers[i].PersonID = filteredCustomers[i]["PersonID$"];
                        filteredCustomers[i].RecipientType = "Customer";
                    }
                    setCustomerList(filteredCustomers);
                }            
        }
    }

    const handleCustomerSelection = async(obj, nextStep) => {

            //Show status warning
            if (obj.Status !== 'Authorized to deal') {//(obj.Status !== 'Authorized to deal') { obj.Status !== 'Regular' && obj.Status !== 'Monitored'
                nextStep = 1;
                setAlertMessage('Customer is in ' + obj.Status + ' status. Orders cannot be created or edited under this customer.');
                setAlertTitle('Warning');
                setShowAlert(true);
            }
            else
            {
                setObjCustomer(obj);
                setCustomerID(obj['Customer ID']);
                setCustomerName(obj['Customer Name']);
                
                loadBeneficiaries(obj["Customer ID"]);

                loadCustomerInfo(obj["Customer ID"]);

                loadInstruments(obj["Customer ID"]);

                if(defaultInstrument === '' || defaultInstrument === undefined){
                    setDefaultInstrument(obj['DefaultSettlementInstrument$']);
                }

                if(defaultSettlementMethod === '' || defaultSettlementMethod === undefined){
                    setDefaultSettlementMethod(obj['DefaultDeliveryMethod$']);
                }



                if (nextStep === 2) {                
                    setStep(nextStep);
                    setObjTicket({});
                }
        }
    }

    const handleContactSelection = (obj) => {
        setStep(3);
        setContactID(obj['Contact ID']);
        setContactName(obj['Name']);
        //setObjTicket(...blankTicket, { BuyCurrency: baseCCy});
    }

    const contacts_length = (n) =>{
        if(n===0){
            setStep(1);
            setAlertTitle('Message');
            setAlertMessage('There are no active customer contacts for this customer.');
        }
    }


    const getTab = () =>{
        if (step === 1 || step === 5) {
            return (
                <ul className="uk-tab">
                    <li key="step-1" className={step !== 5? 'uk-active':''}><a onClick={() => setStep(1)}>Search Customer</a></li>
                    <li key="step-5" className={step === 5? 'uk-active':''}><a onClick={() => setStep(5)}>{`${ticketType} Search`}</a></li>
                </ul>
            );
        }
        else
            return <></>
    }

    const getBreadcrumb = () =>{
        let breadcrumb = [];
        const ticketNo = (objTicket && objTicket.TicketNo > 0)? `: ${objTicket.TicketNo}`:'';
         switch (step) {
                    case 1:
                    default:
                        breadcrumb.push(<Breadcrumb.Item key="bd-ticket" className="breadcrumb-item-bold" onClick={() => setStep(1)}>{`${ticketType} ${ticketNo}`}</Breadcrumb.Item>)   
                        break;
                    case 2:
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-ticket" className="breadcrumb-item" onClick={() => setStep(1)}>{`${ticketType} ${ticketNo}`}</Breadcrumb.Item>
                                    );
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-ticket-cust" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{objCustomer["Customer Name"]} - Select Contact</Breadcrumb.Item>
                                    );
                        break;
                    case 3:
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-ticket" className="breadcrumb-item" onClick={() => setStep(1)}>{`${ticketType} ${ticketNo}`}</Breadcrumb.Item>
                                    );
                        breadcrumb.push(
                                        <Breadcrumb.Item key="bd-ticket-cust" className="breadcrumb-item-bold" onClick={() => setStep(2)}>{`${objCustomer["Customer Name"]} - ${contactName}`} </Breadcrumb.Item>
                                    );
                        break;
                    case 5:
                        breadcrumb.push(<Breadcrumb.Item key="bd-ticket" className="breadcrumb-item-bold" onClick={() => setStep(5)}>Ticket Search</Breadcrumb.Item>)  
                        break;
                    }
        return breadcrumb;
    }

    const backScreen = (obj)=>{
      setObjTicket(obj);
      setStep(3);
    }

    const backToSearchScreen = ()=>{
      setStep(5);
    }

    const cleanTicket = () =>{
        setObjTicket({
            ...blankTicket,
            TicketRows: []
        });
      }

    const cancelTicket = (obj)=>{
      cleanTicket();
      setStep(1);
    }

    const handleTicketSelected = async(responseTicket) =>{
        if(responseTicket && responseTicket.TicketNo > 0)
        {
            if(responseTicket.CustomerID > 0)
            {
                loadCustomerInfo(responseTicket.CustomerID);
                setCustomerID(responseTicket.CustomerID);
                setCustomerName(responseTicket.CustomerName);
                setContactID(responseTicket.ContactID);
                setContactName(responseTicket.ContactName);
                responseTicket.validations = {
                    DeliveryDate: true
                }

                responseTicket.TicketRows.forEach((row,index) =>{
                    row.key = index;
                    //row.DenominationType = DenominationTypes.notes;
                    row.MixedNotes = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true,
                        Condition: true
                    }  
                })

                setObjTicket({...responseTicket});

                setStep(4);
            }

        }
    }

    const newTicket = (ticketCustomerID, ticketContactID, ticketCustomerName, ticketContactName) =>{
        const newOrder = {
            ...blankTicket,
            CustomerID: ticketCustomerID,
            OrderRows: []
        };
        setObjTicket(newOrder);
        setTicketScreenKey(prev => prev + 1);
        if(instruments.length === 0)
        {
            loadCustomerInfo(ticketCustomerID);         
        }
        setCustomerID(ticketCustomerID);
        setContactID(ticketContactID);
        setCustomerName(ticketCustomerName);
        setContactName(ticketContactName);
        
        setStep(3);
    }

    /*
    const getOrderUpdated = async(orderNo) =>{
        const responseOrder = await getOrderInfo(orderNo);
        if(responseOrder)
        {
            if(responseOrder && responseOrder.BNOrderNo > 0)
        {
            if(responseOrder.CustomerID > 0)
            {
                responseOrder.DeliveryTime = responseOrder.DeliveryTimeFormat;
                responseOrder.validations = {
                    DeliveryCustomerID: true,
                    DeliveryDate: true,
                    DeliveryTime: true,
                    DeliveryMethod: true,
                    BuyCurrency: true,
                    CrossRate: true,
                    Instrument: true,
                    SettlementMethod: true,
                    VaultID:true
                }

                responseOrder.OrderRows.forEach((row,index) =>{
                    row.key = index;
                    row.DenominationType = DenominationTypes.notes;
                    row.MixedNotes = !(row.Denominations && row.Denominations.length > 0)
                    row.Denominations = (row.Denominations && row.Denominations.length > 0)? row.Denominations: []
      
                    row.validations={
                        CurrencyID: true,
                        Denominations: true,
                        Amount: true,
                        Rate: true,
                        BuyAmount: true,
                        Condition:true
                    }  
                })

                const showVaultAdd = (responseOrder.BuySell.toLowerCase() === 'buy' && responseOrder.DeliveryMethod.toLowerCase().includes('armored'));

                responseOrder.CanEdit = 0;
                if(showVaultAdd)
                {
                    responseOrder.DeliveryText = responseOrder.VaultAddress;
                }
                setObjOrder(responseOrder);
            }
        }
            setIsEdit(false);
            setStep(4);
        }
    }
*/
    const updateTicketInfo = (obj) =>{
        setObjTicket({...obj});
    }
        
    const getStepScreen = () =>{
        let screen = <></>;
         switch (step) {
                    case 1:
                    default:
                        screen = (<CustomerSearch id="comp_customer_form"
                            onCustomerSelected={handleCustomerSelection} />);         
                        break;
                    case 2:
                        screen = (<ContactSearch id="comp_contact_form"
                                        onContactSelected={handleContactSelection}
                                        contacts_length={contacts_length}
                                        objCustomer={objCustomer} />);
                        break;
                    case 3: if(ticketType === 'Incoming'){
                                screen = <IncomingInformationScreen key={ticketScreenKey} objTicket={objTicket} customerName={customerName} customerID={customerID} 
                                ticketType={ticketType} currenciesList={settlementCurrenciesList}
                                updateTicket={updateTicketInfo} changeScreen={()=> setStep(4)} balances={balances} 
                                contactID={contactID} contactName={contactName} newTicket={newTicket} instruments={instruments} deliveryMethods={deliveryMethods}/>
                            }
                            else{
                                screen = <OutgoingInformationScreen key={ticketScreenKey} objTicket={objTicket} customerName={customerName} customerID={customerID} 
                                ticketType={ticketType} currenciesList={currencies}
                                updateTicket={updateTicketInfo} changeScreen={()=> setStep(4)} balances={balances} beneficiaries={beneficiaries} customers={customerList}
                                contactID={contactID} contactName={contactName} newTicket={newTicket} instruments={instruments} deliveryMethods={deliveryMethods}/>
                            }
                        break;
                    case 4: 
                        screen = <TicketSummary objTicket={objTicket}  ticketType={ticketType}  backScreen={backScreen} cancelTicket={cancelTicket} customerID={customerID} customerName={customerName}
                                contactID={contactID} contactName={contactName} newTicket={newTicket} balances={balances}
                                />
                        break;
                    case 5:
                        screen = <TicketSearchScreen ticketType={ticketType} onTicketSelected={handleTicketSelected}/>;
                        break;
                    }
        return screen;
    }

    
    
    return (<>
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    {getBreadcrumb()}
                </Breadcrumb>
            </div>
            {getTab()}
            {getStepScreen()}
            <AlertBox id="warning-alert"
                                open={showAlert}
                                title={alertTitle}
                                message={alertMessage}
                                type="Ok"
                                okClick={() => setShowAlert(false)}
                            />
    </>)
}

export default TicketScreen